import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius } from '../tokens';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const isCurrentlyActive = (range) => {
  if (!range) return false;
  const now = new Date();
  const curMonth = now.getMonth() + 1;
  const curDay = now.getDate();
  const { startMonth, startDay, endMonth, endDay } = range;
  const afterStart = curMonth > startMonth || (curMonth === startMonth && curDay >= startDay);
  const beforeEnd = curMonth < endMonth || (curMonth === endMonth && curDay <= endDay);
  // Crosses year (e.g. Nov → Mar)
  if (startMonth > endMonth) return afterStart || beforeEnd;
  return afterStart && beforeEnd;
};

const SeasonalAddressCard = ({ address, onMakeDefault }) => {
  const active = address.seasonalRange ? isCurrentlyActive(address.seasonalRange) : true;
  const rangeLabel = address.seasonalRange
    ? `${MONTHS[address.seasonalRange.startMonth - 1]} ${address.seasonalRange.startDay} – ${MONTHS[address.seasonalRange.endMonth - 1]} ${address.seasonalRange.endDay}`
    : 'Year-round';

  return (
    <div style={{
      background: colors.surface,
      border: `1px solid ${address.isDefault ? colors.brand : colors.border}`,
      borderLeft: `3px solid ${active ? colors.success : colors.border}`,
      borderRadius: radius.md,
      padding: space[4],
      display: 'flex',
      gap: space[3],
      alignItems: 'flex-start',
    }}>
      <Icon
        category="utility"
        name="checkin"
        size="small"
        style={{ fill: active ? colors.success : colors.textTertiary, marginTop: 2 }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', gap: space[2], alignItems: 'baseline', flexWrap: 'wrap' }}>
          <span style={{ ...type.body, fontWeight: 700, color: colors.textPrimary }}>
            {address.label || 'Address'}
          </span>
          {address.isDefault && (
            <span style={{
              ...type.micro, fontWeight: 700,
              background: colors.brandMuted, color: colors.brand,
              padding: '1px 8px', borderRadius: radius.pill,
            }}>
              Primary
            </span>
          )}
          {address.seasonalRange && (
            <span style={{
              ...type.micro, fontWeight: 700,
              background: active ? colors.success + '22' : colors.surfaceInk,
              color: active ? colors.success : colors.textTertiary,
              padding: '1px 8px', borderRadius: radius.pill,
            }}>
              {active ? '● Active now' : rangeLabel}
            </span>
          )}
        </div>
        <div style={{ ...type.small, color: colors.textSecondary, marginTop: space[1], lineHeight: 1.5 }}>
          {address.street}<br />
          {address.city}, {address.state} {address.postalCode}
        </div>
        {address.seasonalRange && (
          <div style={{ ...type.micro, color: colors.textTertiary, marginTop: space[1] }}>
            Seasonal: {rangeLabel}
          </div>
        )}
        {!address.isDefault && onMakeDefault && (
          <button
            onClick={() => onMakeDefault(address.id)}
            style={{
              marginTop: space[2],
              padding: `${space[1]}px ${space[2]}px`,
              background: 'transparent',
              color: colors.brand,
              border: `1px solid ${colors.border}`,
              borderRadius: radius.sm,
              ...type.micro,
              fontWeight: 700,
              fontFamily: 'inherit',
              cursor: 'pointer',
            }}
          >
            Make primary
          </button>
        )}
      </div>
    </div>
  );
};

export default SeasonalAddressCard;
